// dtos/assessment.dto.ts

export class OptionDTO {
  id: number = 0;
  title: string = "";
  description: string = "";
  points: number = 0;
  questionId: number = 0;
  createdAt: string = "";
  updatedAt: string = "";

  constructor(data: Partial<OptionDTO> = {}) {
    Object.assign(this, data);
  }
}

export class QuestionDTO {
  id: number = 0;
  title: string = "";
  description: string = "";
  isActive: boolean = false;
  learningStyleId: number = 0;
  coreConceptId: number | null = null;
  createdAt: string = "";
  updatedAt: string = "";
  options: OptionDTO[] = [];

  constructor(data: Partial<QuestionDTO> = {}) {
    Object.assign(this, data);
    this.options = data.options?.map((opt) => new OptionDTO(opt)) || [];
  }
}

export class LearningStyleDTO {
  id: number = 0;
  name: string = "";
  description: string = "";
  point: number = 0;
  createdAt: string = "";
  updatedAt: string = "";
  questions: QuestionDTO[] = [];

  constructor(data: Partial<LearningStyleDTO> = {}) {
    Object.assign(this, data);
    this.questions = data.questions?.map((q) => new QuestionDTO(q)) || [];
  }
}

export class SelectedAnswerDTO {
  questionId: number = 0;
  optionId: number = 0;
  points: number = 0;

  constructor(data: Partial<SelectedAnswerDTO> = {}) {
    Object.assign(this, data);
  }
}

// Single Answer DTO
export class BulkAnswerDTO {
  questionId: number = 0;
  optionId: number = 0;

  constructor(data: Partial<BulkAnswerDTO> = {}) {
    Object.assign(this, data);
  }
}

// Main request DTO
export class SubmitBulkAnswersDTO {
  childId: number = 0;
  answers: BulkAnswerDTO[] = [];
  isForLearning: boolean = false;

  constructor(data: Partial<SubmitBulkAnswersDTO> = {}) {
    Object.assign(this, data);
    this.answers = data.answers?.map((a) => new BulkAnswerDTO(a)) || [];
  }
}
